<template>
  <div :class="$style['other-settings']">
      <pt-sub-title title="其他设置"></pt-sub-title>
      <table :class="$style['other-settings-table']">
          <pt-form-list-item label="售后政策：">{{goodsData.afterSalesPolicyName }}</pt-form-list-item>
          <pt-form-list-item label="内容：">
            <div class="page-background" v-html="goodsData.afterSalesPolicy"></div>
          </pt-form-list-item>
          <pt-form-list-item label="运费规则：" :class="$style['has-top-border']">{{goodsData.carriagePolicyName }}</pt-form-list-item>
          <pt-form-list-item label="内容：">{{goodsData.carriagePolicy }}</pt-form-list-item>
          <pt-form-list-item label="隐私条款：" :class="$style['has-top-border']">
              {{goodsData.privacyPolicyName}}<el-button type="text" @click="review" v-if="hasPrivacyPolicy">查看</el-button>
          </pt-form-list-item>
      </table>
      <el-dialog :visible="isPrivacyPolicy" :class="$style['privacy-policy-dialog']" @close="closeDialog">
        <privacy-policy-content v-if="isPrivacyPolicy" :privacyPolicyId="goodsData.privacyPolicyId"></privacy-policy-content>
      </el-dialog>
  </div>
</template>

<script>
import privacyPolicyContent from 'cps/mall-manage/pt-goods-manage/pt-goods-detail/privacy-policy-content'
export default {
  components: {
    privacyPolicyContent
  },
  props: {
    goodsData: Object
  },
  data () {
    return {
      isPrivacyPolicy: false
    }
  },
  computed: {
    // 是否有隐私条款
    hasPrivacyPolicy () {
      return this.goodsData.privacyPolicyId
    }
  },
  methods: {
    review () {
      this.isPrivacyPolicy = true
    },
    closeDialog () {
      this.isPrivacyPolicy = false
    }
  }
}
</script>

<style module lang="less">
  .other-settings{
  }

  .other-settings-table{
    border-collapse: collapse;
  }

  .has-top-border{
    padding-top:10px;
    border-top: 1px solid #C6C9D3;
    :global
    .el-button{
      margin-left: 10px;
    }
  }

  .privacy-policy-dialog{
    :global
    .el-dialog{
        height: 80%;
        display: flex;
        flex-direction: column;
        .el-dialog__body{
            display: flex;
            flex: 1;
            overflow-y: auto
        }
    }
  }
</style>
